import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { UserProfileService } from '../services/user-profile.service';
import { ModuleAccessDto } from '@core/model/moduleAccessDto';

@Injectable({
  providedIn: 'root'
})
export class ModuleAccessGuard implements CanActivate {

  constructor(
    private router: Router,
    private snackBar: MatSnackBar,
    private translate: TranslateService,
    private userProfileService: UserProfileService
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {
    const moduleCode = (route.data['moduleCode'] || route.data['id']) as string;
    const userModules: ModuleAccessDto[] = this.userProfileService.getUserModules() || [];

    const hasAccessPermission = userModules.some((module: ModuleAccessDto) => {
      if (module.moduleCode !== moduleCode) {
        return false;
      }
      
      const accessLevel = this.getAccessLevelValue(module.access);
      return accessLevel > 0;
    });

    if (hasAccessPermission) {
      return true;
    } else {
      const message = this.translate.instant('PERMISSIONS.NO_ACCESS');
      const closeLabel = this.translate.instant('COMMON.CLOSE');

      this.snackBar.open(message, closeLabel, {
        duration: 3000
      });

      this.router.navigate(['/']);
      return false;
    }
  }

  private getAccessLevelValue(access: any): number {
    if (typeof access === 'number') {
      return access;
    }
    
    const accessMap: { [key: string]: number } = {
      'None': 0,
      'Read': 1,
      'Write': 2,
      'Delete': 3,
      'Full': 4
    };
    
    return accessMap[access] || 0;
  }
}
